import { render } from "./StateSelector.vue?vue&type=template&id=480cb6c0"
import script from "./StateSelector.vue?vue&type=script&lang=js"
export * from "./StateSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__